var map = {
	"./abkhazia.svg": "4678",
	"./ad.svg": "f4b7",
	"./ae.svg": "b4fe",
	"./af.svg": "15c3",
	"./ag.svg": "fb34",
	"./ai.svg": "c595",
	"./al.svg": "9452",
	"./am.svg": "17a4",
	"./ao.svg": "c07a",
	"./ar.svg": "125c",
	"./as.svg": "5913",
	"./at.svg": "6010",
	"./au.svg": "302f",
	"./aw.svg": "4ec2",
	"./ax.svg": "5d29",
	"./az.svg": "40ff",
	"./azores-islands.svg": "5dfe",
	"./ba.svg": "1141",
	"./balearic-islands.svg": "0f8f",
	"./basque-country.svg": "6094",
	"./bb.svg": "a7b3",
	"./bd.svg": "8fdd",
	"./be.svg": "69f7",
	"./bf.svg": "2566",
	"./bg.svg": "c215",
	"./bh.svg": "950b",
	"./bhutan-1.svg": "9d44",
	"./bi.svg": "8c75",
	"./bl.svg": "796b",
	"./bm.svg": "2337",
	"./bn.svg": "5a74",
	"./bo.svg": "52a1",
	"./bonaire.svg": "36a2",
	"./br.svg": "2b1e",
	"./british-columbia.svg": "15ea",
	"./british-indian-ocean-territory.svg": "b5e8",
	"./bs.svg": "2fa4d",
	"./bt.svg": "5ab8",
	"./bw.svg": "c57e",
	"./by.svg": "8225",
	"./bz.svg": "6a97",
	"./ca.svg": "626e",
	"./canary-islands.svg": "e912",
	"./cc.svg": "7371",
	"./ceuta.svg": "1076",
	"./cf.svg": "1d49",
	"./cg.svg": "fd44",
	"./ch.svg": "3c94",
	"./ci.svg": "b9c7",
	"./ck.svg": "8ab7",
	"./cl.svg": "6dcc",
	"./cm.svg": "651c",
	"./cn.svg": "0d9e",
	"./co.svg": "b8de",
	"./corsica.svg": "602e",
	"./cr.svg": "d887",
	"./cu.svg": "66b1",
	"./curacao.svg": "639a",
	"./cv.svg": "76ed",
	"./cx.svg": "1313",
	"./cy.svg": "02bc",
	"./cz.svg": "3952",
	"./de.svg": "31c0",
	"./dj.svg": "5fdc",
	"./dk.svg": "ffbb",
	"./dm.svg": "e007",
	"./do.svg": "f36e",
	"./dz.svg": "e398",
	"./east-timor.svg": "4377",
	"./ec.svg": "8458",
	"./ee.svg": "eabe",
	"./eg.svg": "1f56",
	"./eh.svg": "8df3",
	"./en.svg": "d15e",
	"./er.svg": "be22",
	"./es.svg": "5338",
	"./et.svg": "4fce",
	"./eu.svg": "4562",
	"./fi.svg": "9c87",
	"./fiji.svg": "5ffa",
	"./fk.svg": "6b53",
	"./fm.svg": "6ecc",
	"./fo.svg": "62f1",
	"./fr.svg": "73e5",
	"./ga.svg": "8100",
	"./galapagos-islands.svg": "7244",
	"./gb.svg": "6b93",
	"./gd.svg": "0acd",
	"./ge.svg": "eb4b",
	"./gh.svg": "6b04",
	"./gi.svg": "2fe2",
	"./gl.svg": "2a33",
	"./gm.svg": "d799",
	"./gq.svg": "5db1",
	"./gr.svg": "0473",
	"./gt.svg": "2d5d",
	"./gu.svg": "d60b",
	"./guernsey.svg": "67e7",
	"./guinea.svg": "c8af",
	"./gw.svg": "8f3b",
	"./gy.svg": "d7ca",
	"./hawaii.svg": "c824",
	"./hk.svg": "df6f",
	"./hn.svg": "9ca6",
	"./hr.svg": "ef14",
	"./ht.svg": "0628",
	"./hu.svg": "e2c4",
	"./id.svg": "343b",
	"./ie.svg": "130b",
	"./il.svg": "c55a",
	"./im.svg": "0916",
	"./in.svg": "cac5",
	"./iq.svg": "a432",
	"./ir.svg": "edfe",
	"./is.svg": "a554",
	"./it.svg": "6523",
	"./je.svg": "18a5",
	"./jm.svg": "8ad8",
	"./jo.svg": "4c73",
	"./jp.svg": "d52a",
	"./ke.svg": "a9d7",
	"./kg.svg": "28c4",
	"./kh.svg": "d4ce",
	"./kiribati.svg": "ca28",
	"./km.svg": "ec0d",
	"./kosovo.svg": "92a0",
	"./kp.svg": "3c95",
	"./kr.svg": "2379",
	"./kw.svg": "b6ca",
	"./ky.svg": "c491",
	"./kz.svg": "f12d",
	"./la.svg": "a73a",
	"./lb.svg": "f698",
	"./lc.svg": "5740",
	"./li.svg": "5d2c",
	"./lk.svg": "b2c6",
	"./lr.svg": "766b",
	"./ls.svg": "bb35",
	"./lt.svg": "28d8",
	"./lu.svg": "3208",
	"./lv.svg": "688e",
	"./ly.svg": "f751",
	"./ma.svg": "be71",
	"./madeira.svg": "1daa",
	"./mc.svg": "c686",
	"./md.svg": "07e5",
	"./me.svg": "483c",
	"./melilla.svg": "9f8d",
	"./mg.svg": "4b73",
	"./mh.svg": "3445",
	"./ml.svg": "e838",
	"./mm.svg": "e79d",
	"./mn.svg": "410f",
	"./mo.svg": "5190",
	"./mp.svg": "2402",
	"./mq.svg": "7603",
	"./mr.svg": "295f",
	"./ms.svg": "f749",
	"./mt.svg": "e546",
	"./mu.svg": "5322",
	"./mv.svg": "afba",
	"./mw.svg": "e4f7",
	"./mx.svg": "80d1",
	"./my.svg": "ee4f",
	"./mz.svg": "3542",
	"./na.svg": "36fc",
	"./nato.svg": "75ef",
	"./ni.svg": "d5bd",
	"./niger.svg": "34ca",
	"./nigeria.svg": "90c6",
	"./niue.svg": "0016",
	"./nj.svg": "1d90",
	"./nl.svg": "8824",
	"./no.svg": "babd",
	"./norfolk-island.svg": "f411",
	"./northen-cyprus.svg": "0da3",
	"./np.svg": "3043",
	"./nr.svg": "0bdb",
	"./nz.svg": "63a8",
	"./om.svg": "bdf4",
	"./orkney-islands.svg": "10b1",
	"./ossetia.svg": "6aaa",
	"./pa.svg": "c9bf",
	"./pe.svg": "d838",
	"./pf.svg": "a9b5",
	"./pg.svg": "f5ec",
	"./ph.svg": "8f3b9",
	"./pk.svg": "c7a8",
	"./pl.svg": "df8b",
	"./pn.svg": "52d0",
	"./pr.svg": "451d",
	"./ps.svg": "d2fe",
	"./pt.svg": "7c36",
	"./pw.svg": "23d4",
	"./py.svg": "20a8",
	"./qa.svg": "f2e4",
	"./rapa-nui.svg": "0831",
	"./republic-of-macedonia.svg": "8f42",
	"./republic-of-the-congo.svg": "08da",
	"./ro.svg": "41f8",
	"./rs.svg": "0d82",
	"./ru.svg": "8c28",
	"./rw.svg": "f833",
	"./sa.svg": "8a52",
	"./saba-island.svg": "b6d1",
	"./saint-kitts-and-nevis.svg": "2462",
	"./sb.svg": "0a7e",
	"./sc.svg": "2c8a",
	"./scotland.svg": "8b8c",
	"./sd.svg": "b115",
	"./se.svg": "5f84",
	"./sg.svg": "faa5",
	"./si.svg": "697f",
	"./sint-eustatius.svg": "db0a",
	"./sk.svg": "d5cc",
	"./sl.svg": "60a6",
	"./sm.svg": "8ab4",
	"./sn.svg": "d629",
	"./so.svg": "4283",
	"./somaliland.svg": "af16",
	"./sr.svg": "1659",
	"./ss.svg": "ab77",
	"./st.svg": "88fb",
	"./sv.svg": "a752",
	"./sx.svg": "2735",
	"./sy.svg": "8573",
	"./sz.svg": "322a",
	"./tc.svg": "1b4a",
	"./td.svg": "beaf",
	"./tg.svg": "4555",
	"./th.svg": "509b",
	"./tibet.svg": "1cbe",
	"./tj.svg": "76cf",
	"./tk.svg": "fe26",
	"./tm.svg": "0e93",
	"./tn.svg": "43be",
	"./tokelau.svg": "4527",
	"./tr.svg": "2ecb",
	"./transnistria.svg": "eb71",
	"./tt.svg": "7bca",
	"./tv.svg": "21e4",
	"./tw.svg": "66c1",
	"./tz.svg": "2eb1",
	"./ua.svg": "8ac8",
	"./ug.svg": "da13",
	"./uk.svg": "1a7f",
	"./un.svg": "0e3a",
	"./us.svg": "1ab6",
	"./uy.svg": "cc0f",
	"./uz.svg": "36d6",
	"./vatican-city.svg": "8a88",
	"./vc.svg": "1487",
	"./ve.svg": "7aa4",
	"./vg.svg": "98ff",
	"./vi.svg": "441e",
	"./vn.svg": "e165",
	"./vu.svg": "b1c0",
	"./wales.svg": "6ba7",
	"./ws.svg": "eea8",
	"./ye.svg": "b878",
	"./za.svg": "1959",
	"./zm.svg": "0638",
	"./zw.svg": "d400"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "29f0";